export default function isToday(date: Date | string | number): boolean {
  date = date instanceof Date ? date : new Date(date);
  const today = new Date();
  return (
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
  );
}
